<template>
	<v-search-data-provider :api-url="apiUrl">
		<template slot-scope="dataProvider">
			<v-search
				:api-url="apiUrl"
				:url="url"
				:items="dataProvider.items"
				:id="searchId"
				:use-animation="useAnimation"
				@getItems="dataProvider.getItems"
				:max-index="dataProvider.items.length - 1"
				:input-value="inputValue"
				:is-loading="dataProvider.loading">
			</v-search>
		</template>
	</v-search-data-provider>
</template>

<script>
import VSearchDataProvider from '../../components/search/VSearchDataProvider.vue';
import VSearch from '../../components/search/VSearch.vue';

export default {
    name: 'VSearchWrapper',
	components: {
		VSearch,
		VSearchDataProvider
	},
	props: {
		apiUrl: {
			type: String,
			default: ''
		},
		searchId: {
			type: String,
			default: ''
		},
		largeInput: {
			type: Boolean,
			default: false
		},
		url: {
			type: String,
			default: ''
		},
		useAnimation: {
			type: Boolean,
			default: false
		},
		inputValue: {
			type: String,
			default: ''
		}
	}
}
</script>
